import { render, staticRenderFns } from "./PostalPatchList.vue?vue&type=template&id=552e955d&scoped=true"
import script from "./PostalPatchList.vue?vue&type=script&lang=js"
export * from "./PostalPatchList.vue?vue&type=script&lang=js"
import style0 from "./PostalPatchList.vue?vue&type=style&index=0&id=552e955d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e955d",
  null
  
)

export default component.exports